import { render } from "./ProjectsHeader.vue?vue&type=template&id=72f197b1&scoped=true"
import script from "./ProjectsHeader.vue?vue&type=script&lang=js"
export * from "./ProjectsHeader.vue?vue&type=script&lang=js"

import "./ProjectsHeader.vue?vue&type=style&index=0&id=72f197b1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f197b1"]])

export default __exports__